export default __webpack_public_path__ + "static/media/logo.7282a794.png";